export const APP_PATHS = {
  HOME: '',
  LOGIN: 'login',
  REGISTER: 'register',
  PRIVACY_POLICY: 'privacy-policy',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  CONFIRM_EMAIL: 'confirm-email',
  PROFILE: 'profile',
  WEBSOCKET_TEST: 'websocket-test',
  CREATE_PLAYLIST: 'playlist/create',
  ADMIN: 'admin',
  USER_PAGE: 'user/:username',
} as const;
